export const defaultValuesForm = (currentProduct: Partial<any> | undefined) => ({

});
